<template>
  <div>
    <!-- 预览pdf.word等文件格式 -->
    <pdf-show ref="pdfSearch" :iframeSrc="src" :pdf-visible="pdfVisible" @pdfCLose="pdfCLose" />
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapState } from 'vuex'
import req from '@/request'
import PdfShow from '@/components/pdfOutLine/index.vue'
export default {
  components: { PdfShow },
  data() {
    return {
      fileRow: '',
      iframeSrc: '',
      iframeType: 'jpg',
      src: '',
      fileTree: '',
      pdfVisible: false,
      typeList: [
        'jpg',
        'jpeg',
        'png',
        'bmp',
        'pdf',
        'JPG',
        'JPEG',
        'PBG',
        'BMP',
        'PDF',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'xlsm',
        'ppt',
        'pptx',
        'rtf',
        'txt',
        'zip',
        'rar',
        'vsd',
        'dwg',
        'mp4',
        'avi',
        '3gp',
        'rmvb',
        'rm',
        'wmv'
      ]
    }
  },
  computed: mapState({
    header: (state) => {
      return { Authorization: `Bearer ${state.login.currentUser.token}` }
    },
    actionUrl: function () {
      return req.getContext().portal + '/system/file/v1/upload'
    }
  }),
  mounted() {},
  methods: {
    pdfCLose() {
      this.pdfVisible = false
    },
    containTypeList(name) {
      return this.typeList.some((item) => name.indexOf(item) > -1)
    },
    preview(row) {
      if (this.containTypeList(row.name)) {
        this.$store.dispatch('menu/onlinePreview', row.id).then((data) => {
          if (data.result === 'error') {
            Message.error('附件不存在')
          } else {
            this.src = window.context.manage + '/convert/onlinePreview?url=' + encodeURIComponent(Base64.encode(data.signedUrl))
            this.pdfVisible = true
            this.$nextTick(() => {
              this.$refs.pdfSearch.pdfUrlShow()
            })
          }
        })
      } else {
        this.$store.dispatch('menu/downloadFile', row.id)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.upload-demo {
    max-width: 570px;
    margin-top: 5px;
}
</style>
